// extracted by mini-css-extract-plugin
module.exports = {"maxWidthContainer":"ActiveJobs-module--maxWidthContainer--1IGG0","openings":"ActiveJobs-module--openings--VRQCs","openingBox":"ActiveJobs-module--openingBox--2XIqM"};